import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { BaseComponent } from '../../base.component';
import { MatSelectChange } from '@angular/material/select';
import { CategoryService } from 'src/app/services/category.service';

@Component({
  selector: 'map-filter-dropdowns',
  templateUrl: './map-filter-dropdowns.component.html',
  styleUrls: ['./map-filter-dropdowns.component.css']
})
export class MapFilterDropdownsComponent extends BaseComponent implements OnInit, OnDestroy {
  @Input() entities
  @Output() filterSelected = new EventEmitter<any>()
  entityList
  title
  dropdownData = []
  constructor(private categoryService: CategoryService) {
    super()
  }
  async ngOnInit() {
    for (let entity of this.entities) {

      if (entity === 'revenueCode') {
        let revenueCodes = await this.categoryService.getList("revenue-code").toPromise();
        revenueCodes = revenueCodes.map(rC => ({ ...rC, codeName: `${rC.code} - ${rC.name}` }));
        this.dropdownData.push({ title: entity.toUpperCase(), data: revenueCodes })
      }
    }
  }
  ngOnDestroy(): void {
    super.ngOnDestroy()
  }

  onSelect(data, entity) {
    switch (entity) {
      case 'REVENUECODE':
        this.filterSelected.emit(data.data.length > 0 ? { 'revenue_code': data.data[0].code } : null)
        break;
      default:
        break;
    }
  }
}
